import { useState, FC, useEffect } from "react";
import { Popover } from "@headlessui/react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import { getHotelSelectedData } from "services/get-hotel-selected-data";

export interface StayDatesRangeInputProps {
  className?: string;
}

const StayDatesRangeInputForm: FC<StayDatesRangeInputProps> = ({
  className = "flex-1",
}) => {
  const [startDate, setStartDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();
  // const [hotelSelectedStorage, setHotelSelectedStorage] = useState<
  //   RootHotelSelected | undefined
  // >();
  // const metadata = useMetadataHotel();
  // const { profile } = useMetadataUser();

  useEffect(() => {
    const hotelSelected = getHotelSelectedData();
    if (hotelSelected) {
      // setHotelSelectedStorage(hotelSelected);
      const checkInDateTypeDate = new Date(
        `${hotelSelected.checkInDate}T00:00:00.000`
      );
      const checkoutDate = new Date(checkInDateTypeDate);
      checkoutDate.setDate(
        checkInDateTypeDate.getDate() + hotelSelected.numNights
      );
      setStartDate(checkInDateTypeDate);
      setEndDate(checkoutDate);
    }
  }, []);

  // const { setCheckInDate, setNumNights } = useHotels();

  // const onChangeDate = (dates: [Date | null, Date | null]) => {
  //   const [start, end] = dates;

  //   if (
  //     start &&
  //     end &&
  //     profile?.subscription?.active &&
  //     profile?.subscription.points > 0
  //   ) {
  //     const rangeInMilliseconds = end.getTime() - start.getTime();
  //     const rangeInDays = rangeInMilliseconds / (1000 * 60 * 60 * 24);
  //     if (rangeInDays > profile.subscription.points) {
  //       toast.error(
  //         `O intervalo de datas não pode ser maior que ${profile.subscription.points} dias`
  //       );
  //       return;
  //     }
  //   }
  //   setStartDate(start);
  //   setEndDate(end);

  //   if (start && end && end.getTime() !== start.getTime()) {
  //     const startDateFormated = Formatter.prettyDateHifen(start);
  //     const rangeInMilliseconds = end.getTime() - start.getTime();
  //     const rangeInDays = rangeInMilliseconds / (1000 * 60 * 60 * 24);
  //     setCheckInDate(startDateFormated);
  //     setNumNights(rangeInDays);

  //     const newHotelSelectedStorage = {
  //       ...hotelSelectedStorage,
  //       checkInDate: startDateFormated,
  //       numNights: rangeInDays,
  //     };

  //     metadata.setNumNights(rangeInDays);

  //     localStorage.setItem(
  //       "hotelSelected",
  //       JSON.stringify(newHotelSelectedStorage)
  //     );
  //   }
  // };

  const renderInput = () => {
    return (
      <>
        <div className="text-neutral-300 dark:text-neutral-400">
          <CalendarIcon className="w-5 h-5 lg:w-7 lg:h-7" />
        </div>
        <div className="w-full flex-grow text-left">
          <span className="block xl:text-lg font-semibold">
            {startDate?.toLocaleDateString("pt-BR", {
              month: "short",
              day: "2-digit",
            }) ?? "Adicionar datas"}
            {endDate
              ? " - " +
                endDate?.toLocaleDateString("pt-BR", {
                  month: "short",
                  day: "2-digit",
                })
              : ""}
          </span>
          <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
            {"Check in - Check out"}
          </span>
        </div>
      </>
    );
  };

  return (
    <Popover className={`StayDatesRangeInput z-10 relative flex ${className}`}>
      {({ open }) => (
        <>
          <Popover.Button
            className={`flex-1 flex relative p-1 md:p-3 mb-2 md:mb-0 items-center mx-auto cursor-default space-x-3 focus:outline-none ${
              open ? "shadow-lg" : ""
            }`}
          >
            {renderInput()}
            {/* {startDate && open && (
               <ClearDataButton onClick={() => onChangeDate([null, null])} />
         
            )} */}
          </Popover.Button>

          {/* <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute left-auto xl:-right-10 top-full right-0 z-10 mt-3 w-screen max-w-sm px-4 sm:px-0 lg:max-w-3xl">
              <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5 bg-white dark:bg-neutral-800 p-8">
                <DatePicker
                  disabled
                  formatWeekDay={(nameOfDay) =>
                    weekdays[
                      weekdays.findIndex((day) => day.enUS === nameOfDay)
                    ].ptBR
                  }
                  selected={startDate}
                  // onChange={onChangeDate}
                  onChange={() => {}}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  monthsShown={2}
                  showPopperArrow={false}
                  inline
                  renderCustomHeader={(p) => (
                    <DatePickerCustomHeaderTwoMonth {...p} />
                  )}
                  renderDayContents={(day, date) => (
                    <DatePickerCustomDay dayOfMonth={day} date={date} />
                  )}
                />
                <Toaster
                  position="top-center"
                  toastOptions={{
                    duration: 5000,
                  }}
                />
              </div>
            </Popover.Panel>
          </Transition> */}
        </>
      )}
    </Popover>
  );
};

export default StayDatesRangeInputForm;
